import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://cah.test/data.php";

// The PHP backend (data.php) returns { error: "..." } on failure, and some
// actions (startGame, pickWinner) return an empty body on success.
function unwrap(response) {
  const data = response.data;
  if (data && data.error) {
    throw new Error(data.error);
  }
  return data;
}

async function call(params) {
  const response = await axios.get(API_URL, { params });
  return unwrap(response);
}

export function createGame(name) {
  return call({ a: "createGame", name });
}

export function joinGame(code, name) {
  return call({ a: "joinGame", code, name });
}

// The polling endpoint. Returns the full game object (with nested players).
export function getGame(code) {
  return call({ a: "getGame", code });
}

// Returns an empty body; follow with getGame to read the new state.
export function startGame(code) {
  return call({ a: "startGame", code });
}

// player is the player's own id; card is the card text being played.
// Echoes the updated game object.
export function playCard(playerId, card) {
  return call({ a: "playCard", player: playerId, card });
}

// player is the id of the player whose card the judge chose as the winner.
// Returns an empty body; follow with getGame.
export function pickWinner(winnerPlayerId) {
  return call({ a: "pickWinner", player: winnerPlayerId });
}

export function quitPlayer(playerId) {
  return call({ a: "quitPlayer", player: playerId });
}
